<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="Scatter Charts"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Basic Scatter Chart</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="basicScatterChart.series"
					[chart]="basicScatterChart.chart"
					[xaxis]="basicScatterChart.xaxis"
					[yaxis]="basicScatterChart.yaxis"
					[colors]="basicScatterChart.colors"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Scatter - Datetime Chart</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="dateTimeScatterChart.series"
					[chart]="dateTimeScatterChart.chart"
					[xaxis]="dateTimeScatterChart.xaxis"
					[yaxis]="dateTimeScatterChart.yaxis"
					[dataLabels]="dateTimeScatterChart.dataLabels"
					[grid]="dateTimeScatterChart.grid"
					[colors]="dateTimeScatterChart.colors"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Scatter Images Chart</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="ScatterImagesChart.series"
					[chart]="ScatterImagesChart.chart"
					[xaxis]="ScatterImagesChart.xaxis"
					[yaxis]="ScatterImagesChart.yaxis"
					[colors]="ScatterImagesChart.colors"
					[grid]="ScatterImagesChart.grid"
					[markers]="ScatterImagesChart.markers"
					[fill]="ScatterImagesChart.fill"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->
